var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cg-head"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"selcountry"},[_c('Webapp'),_c('TransLang')],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }